import { ESystemMobile } from '../types/enums';

const isIPadOS = () =>
  navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;

const detectMobile = () => {
  return /iPhone|iPad|iPod|Android|webOS|BlackBerry|Windows Phone/i.test(
    navigator.userAgent,
  ) || isIPadOS();
};

const detectSystemMobile = () => {
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || isIPadOS();
  const isAndroid = /Android/.test(navigator.userAgent);

  if (isIOS) {
    return ESystemMobile.IOS;
  } else if (isAndroid) {
    return ESystemMobile.ANDROID;
  } else {
    return ESystemMobile.OTHER;
  }
};

export { detectMobile, detectSystemMobile };
